import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { translations } from '../i18n/translations';

const LanguageContext = createContext(null);

function getValue(source, path) {
  return path.split('.').reduce((value, key) => value?.[key], source);
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem('siteLanguage') || localStorage.getItem('articlesLang') || localStorage.getItem('lang');
    return saved === 'EN' ? 'EN' : 'RU';
  });

  useEffect(() => {
    localStorage.setItem('siteLanguage', lang);
    localStorage.setItem('articlesLang', lang);
    localStorage.setItem('lang', lang);
    document.documentElement.lang = lang === 'EN' ? 'en' : 'ru';
  }, [lang]);

  const value = useMemo(() => ({
    lang,
    setLang,
    locale: lang === 'EN' ? 'en-US' : 'ru-RU',
    t: (path, fallback) => getValue(translations[lang], path) ?? fallback ?? path,
  }), [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguageContext() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used inside LanguageProvider');
  return context;
}
